import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ResponsibilityCenterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
}

const initialState: ResponsibilityCenterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
};

export const responsibilityCenterSlice = createSlice({
  name: 'responsibilityCenter',
  initialState,
  reducers: {
    // For paginated fetch (default listing)
    setAllResponsibilityCenter: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalElements;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.number;
    },

    // For search results
    setAllResponsibilityCenterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.totalRecords;
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
    },

    // Reset all state
    reset: () => initialState,
  },
});

// Action creators are generated for each case reducer function
export const { setAllResponsibilityCenter, setAllResponsibilityCenterBySearch, reset } = responsibilityCenterSlice.actions;
export const getAllResponsibilityCenterDetails = (state: RootState) => state.responsibilityCenter.data;
export const getAllResponsibilityCenterBySearch = (state: RootState) => state.responsibilityCenter.data;
export const getResponsibilityCenterTotalRecords = (state: RootState) => state.responsibilityCenter.totalRecords;

export default responsibilityCenterSlice.reducer;